module.exports = __webpack_public_path__ + "img/H01060-02.358db96e.jpg";